import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { NavLink as Link } from 'react-router-dom'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import ReactMarkdown from 'react-markdown'
import NavigationAppShell from '../../common/navigation-app-shell'
import Y from '../../y18n'
import Styles from '../../common/styles'
import * as productActions from '../../store/products'
import * as pageTextActions from '../../store/page-texts'
import DisplayProductCard from '../../common/display-product-card'
import DisplayProductCardSkeleton from '../../common/display-product-card-skeleton'

const mapStateToProps = state => ({
  products: state.products,
  locales: state.locales,
  pageTexts: state.pageTexts
})

const mapDispatchToProps = dispatch => ({
  productActions: bindActionCreators(productActions, dispatch),
  pageTextActions: bindActionCreators(pageTextActions, dispatch)
})

class RenewPage extends Component {
  state = {
    imsi: ''
  }

  componentDidMount () {
    if (!this.state.imsi) {
      if (this.props.match.params.imsi) {
        this.setState({ imsi: this.props.match.params.imsi })
        this.props.productActions.getDisplayProducts(this.props.locales.country)
      }
    }
    this.props.pageTextActions.getPageText('RenewPage', this.props.locales.country, this.props.locales.language)
  }

  render () {
    const { classes, products, pageTexts } = this.props
    return (
      <NavigationAppShell
        content={
          <div>
            <div className={classes.textRow}>
              <Typography variant='title' style={{ fontSize: '32px' }}>
                {Y`Renew subscription`}
              </Typography>
              <Typography variant='subheading'>
                {Y`With IMSI number`}{' '}{this.state.imsi}
              </Typography>
              <Typography variant='body2'>
                <Link to={'/subscriptions'} className={classes.themeLink}>{Y`Back to my subscriptions`}</Link>
              </Typography>
            </div>
            <Grid container spacing={40} style={{ minHeight: '100%', justifyContent: 'center' }}>
              {!products.displayItems || !products.displayItems.length > 0
                ? <DisplayProductCardSkeleton cards={3} mdSize={6} />
                : products.displayItems.map((product, index) => (
                  <Grid item key={index} xs={12} sm={12} md={6} className={classes.col}>
                    <DisplayProductCard
                      displayProduct={product}
                      country={this.props.locales.country}
                      language={this.props.locales.language}
                      imsi={this.state.imsi}
                      />
                  </Grid>
                  ))}
            </Grid>
            <div className={classes.textRow} style={{ marginTop: '60px' }}>
              <Typography variant='title'>{Y`General information`}</Typography>
            </div>
            <Grid container spacing={40} style={{ minHeight: '100%' }}>
              <Grid item xs={12}>
                <Paper className={classes.content}>
                  {pageTexts.item && <ReactMarkdown source={pageTexts.item.content} escapeHtml={false} />}
                </Paper>
              </Grid>
            </Grid>
          </div>
        }
        pageName={'Renew'}
      />
    )
  }
}

RenewPage = connect(mapStateToProps, mapDispatchToProps)(RenewPage)
export default withStyles(Styles)(RenewPage)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/renew.js